<div class="navbar_inner_area">
  <nav class="navigation-area overlay sticky-navbar fadeInUp" [ngClass]="{'sticky': sticky}" (scroll)="onElementScroll()" data-sticky-offset="50">
    <div class="holder">
      <div class="menu_toggle" (click)="menuToggle()">
        <i class="fa fa-align-left"></i>
      </div>
      <a routerLink="/" class="brand-logo">
        <img *ngIf="property.logoUrl !== null && property.logoUrl !== undefined" [src]="property.logoUrl" alt="logo" class="logo">
        <img *ngIf="property.logoUrl == null && property.logoUrl == undefined" src="assets/images/Logo-kalinga.jpg" alt="logo" class="logo">
        <!-- <img src="{{token.getProperty().logoUrl}}" alt=""> -->
      </a>
      <div class="navbar-mobile" [ngClass]="{'active': mobileActive}">
        <ul class="navbar-nav single-item-right">
          <li class="">
            <a routerLink="/">
              Home
            </a>

          </li>
          <li>
            <a routerLink="/all-rooms">
              Rooms
            </a>
            <!-- <ul class="DropDown">
                          <li>
                              <a href="">
                                  All Rooms
                              </a>
                          </li>
                          <li>
                              <a href="room2.php">
                                  room-2
                              </a>
                          </li>
                          <li>
                              <a href="room-details.php">
                                  Room details
                              </a>
                          </li>
                      </ul> -->
          </li>
          <!-- <li>
            <a routerLink="/menu/Feathers-Hospitality-Flora-Eco-Stay">
              Menu
            </a>
          </li> -->
          <li>
            <a routerLink="/services">
              Service
            </a>
          </li>
          <li>
            <a routerLink="/gallery">Gallery</a>
          </li>
          <li>
            <a routerLink="/aboutus">
              About Us
            </a>
          </li>
          <li>
            <a routerLink="/contact">
              Contact
            </a>
          </li>
          <li>
              <a routerLink="/booking/choose" target="blank" class=" common_btn1 btn_hbreffect" style="margin-top: 8px; padding: 15px;">Book now</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
